import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=09685c97&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=js&"
export * from "./SelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09685c97",
  null
  
)

export default component.exports